import { Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from '@/components/AppShell'
import { RequireAuth, RequireDataset } from '@/components/Gate'
import { FilterProvider } from '@/data/filters'
import { AppDataProvider } from '@/data/AppData'
import { Overview } from '@/pages/Overview'
import { EmployeeView, SupervisorViewRedirect } from '@/pages/EmployeeView'
import { ClaimDetail } from '@/pages/ClaimDetail'
import { TouchDetail } from '@/pages/TouchDetail'
import { Employees } from '@/pages/Employees'
import { Facilities } from '@/pages/Facilities'
import { Scorecard } from '@/pages/Scorecard'
import { Supervisors } from '@/pages/Supervisors'
import { Backlog } from '@/pages/Backlog'
import { TouchProfile } from '@/pages/TouchProfile'
import { TouchDrivers } from '@/pages/TouchDrivers'
import { DataMethod } from '@/pages/DataMethod'
import { PayrollWithoutClaims } from '@/pages/PayrollWithoutClaims'
import { TerminatedWorklists } from '@/pages/TerminatedWorklists'
import { WorklistAssignments } from '@/pages/WorklistAssignments'
import { Access } from '@/pages/Access'
import { Rules } from '@/pages/Rules'
import { StatementsAdmin } from '@/pages/StatementsAdmin'
import { AccessProvider } from '@/access/AccessContext'
import { CommentsProvider } from '@/comments/reviewHost'
import { WeightsProvider } from '@/data/weights'

export function App() {
  return (
    <RequireAuth>
      <RequireDataset>
        <FilterProvider>
          {/* Above AppDataProvider: the drill-through it renders shows comments too. */}
          <CommentsProvider>
          <WeightsProvider>
          <AppDataProvider>
            <AccessProvider>
            <Routes>
              <Route element={<AppShell />}>
                <Route index element={<Overview />} />
                <Route path="employee-view" element={<EmployeeView />} />
                <Route path="supervisor-view" element={<SupervisorViewRedirect />} />
                <Route path="employees" element={<Employees />} />
                <Route path="scorecard" element={<Scorecard />} />
                <Route path="supervisors" element={<Supervisors />} />
                <Route path="facilities" element={<Facilities />} />
                <Route path="backlog" element={<Backlog />} />
                <Route path="touch" element={<TouchProfile />} />
                <Route path="touch-drivers" element={<TouchDrivers />} />
                {/*
                  The standalone Month over month page is gone — its grid lives on the
                  Scorecard, where the question it answers belongs. The route stays as
                  a redirect so a bookmark or a pasted link still lands somewhere real
                  rather than on a blank page.
                */}
                <Route path="months" element={<Navigate to="/scorecard" replace />} />
                <Route path="claim-detail" element={<ClaimDetail />} />
                <Route path="touch-detail" element={<TouchDetail />} />
                <Route path="worklist-assignments" element={<WorklistAssignments />} />
                <Route path="terminated" element={<TerminatedWorklists />} />
                <Route path="payroll-without-claims" element={<PayrollWithoutClaims />} />
                <Route path="method" element={<DataMethod />} />
                <Route path="access" element={<Access />} />
                <Route path="rules" element={<Rules />} />
                <Route path="statements" element={<StatementsAdmin />} />
              </Route>
            </Routes>
            </AccessProvider>
          </AppDataProvider>
          </WeightsProvider>
          </CommentsProvider>
        </FilterProvider>
      </RequireDataset>
    </RequireAuth>
  )
}
